import { Flex, Typography, theme } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import { memo } from 'react';
import { formatIntegration } from '../../../../../../utils/formatIntegration';

export const defaultIntegrationMethods = [
  'cloudflare',
  'node',
  'nuxt',
  'ruby',
  'nginx',
  'apache',
  'iis',
  'docker',
  'firebase',
  'magento-2',
  'hapi',
  'koa',
  'django',
  'aspnet-core',
  'spring',
  'laravel',
  'bubble',
  'fastly',
  'NextJS',
  'lovable-free',
  'lovable-paid',
  'akamai',
];
const ONBOARDING_IMAGE_PATH = '/assets/img/onboarding/';

const { Text } = Typography;

const Integrations = ({
  selectedMethod,
  setSelectedMethod,
  integrations = defaultIntegrationMethods,
  collapsed = false,
}) => {
  const { token } = theme.useToken();

  return (
    <Flex vertical gap={token.margin}>
      {integrations.map((integration) => {
        const isSelected = selectedMethod === integration;

        return (
          <button
            key={integration}
            type="button"
            // Collapsed the name has nowhere to go, so the icon carries the
            // whole entry and the accessible name carries what it is.
            aria-label={collapsed ? formatIntegration(integration) : undefined}
            aria-pressed={isSelected}
            style={{
              width: '100%',
              // Figma draws the border inside the 80px card.
              padding: token.padding - token.lineWidth,
              cursor: 'pointer',
              textAlign: 'left',
              borderRadius: token.borderRadiusLG,
              border: `${token.lineWidth}px solid ${isSelected ? token.colorPrimary : token.colorBorderSecondary}`,
              background: isSelected ? token.colorPrimaryBg : token.colorBgContainer,
            }}
            onClick={() => {
              setSelectedMethod(integration);
            }}
          >
            <Flex align="center" gap={token.marginXS}>
              <Flex
                align="center"
                justify="center"
                style={{
                  width: token.sizeXXL,
                  height: token.sizeXXL,
                  flexShrink: 0,
                  borderRadius: '50%',
                  background: token.colorBgContainer,
                }}
              >
                <img
                  src={`${ONBOARDING_IMAGE_PATH + integration.toLowerCase()}.svg`}
                  width={token.sizeLG}
                  height={token.sizeLG}
                  alt={integration}
                />
              </Flex>
              {!collapsed && (
                <>
                  <Text strong style={{ flex: 1, minWidth: 0 }}>
                    {formatIntegration(integration)}
                  </Text>
                  <ArrowRightOutlined
                    aria-hidden
                    style={{ color: token.colorPrimary, fontSize: token.fontSizeHeading3 }}
                  />
                </>
              )}
            </Flex>
          </button>
        );
      })}
    </Flex>
  );
};

export default memo(Integrations);
